import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-banner[type][header][message]',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

  dynamicBannerClass = 'banner-info';

  @Input() type: 'info' | 'warning' | 'error';
  @Input() header: string;
  @Input() message: string;

  constructor() {
  }

  ngOnInit(): void {
    switch (this.type) {
      case 'info':
        this.dynamicBannerClass = 'banner-info';
        break;
      case 'warning':
        this.dynamicBannerClass = 'banner-warn';
        break;
      case 'error':
        this.dynamicBannerClass = 'banner-error';
        break;
    }
  }

}
